import { createSlice } from "@reduxjs/toolkit";

export const tripsSlice = createSlice({
  name: "trips",
  initialState: {
    list: [],
    meta: {},
    tripDetails: {},
  },
  reducers: {
    getTripsListRequest: () => {},
    getTripsListResponse: (state, action) => {
      state.list = action.payload?.trips;
      state.meta = action.payload?.meta;
    },
    getTripsDetailsRequest: () => {},
    getTripsDetailsResponse: (state, action) => {
      state.tripDetails = action.payload;
    },
    forceEndTripRequest: () => {},
  },
});

export const {
  getTripsListRequest,
  getTripsListResponse,
  getTripsDetailsRequest,
  getTripsDetailsResponse,
  forceEndTripRequest,
} = tripsSlice.actions;
export default tripsSlice.reducer;
